import { EditMode } from "@drillflo/drillcore/lib/2d/Engine";
import { useCallback, useState, useContext } from "react";

export interface FieldEditorData {
  editMode: string;
  setEditMode: (editMode: string) => void;
  showAudioTrackModal: boolean;
  setShowAudioTrackModal: (showAudioTrackModal: boolean) => void;
  showFeildSettingsModal: boolean;
  setShowFeildSettingsModal: (showFeildSettingsModal: boolean) => void;
  showPerformerLabelModal: boolean;
  setShowPerformerLabelModal: (showPerformerLabelModal: boolean) => void;
  showCoordinateSheetModal: boolean;
  setShowCoordinateSheetModal: (showCoordinateSheetModal: boolean) => void;
  showBulkEditPerformerLabelModal: boolean;
  setShowBulkEditPerformerLabelModal: (
    showBulkEditPerformerLabelModal: boolean
  ) => void;
  showExportDialog: boolean;
  setShowExportDialog: (showExportDialog: boolean) => void;
  showDeletePerformersModal: boolean;
  setShowDeletePerformersModal: (showDeletePerformersModal: boolean) => void;
  isShortcutsOpen: boolean;
  setIsShortcutsOpen: (isShortcutsOpen: boolean) => void;
}

export default function useFieldEditor() {
  const [editMode, setEditMode] = useState("PAN");
  const [showAudioTrackModal, setShowAudioTrackModal] = useState(false);
  const [showFeildSettingsModal, setShowFeildSettingsModal] = useState(false);
  const [showPerformerLabelModal, setShowPerformerLabelModal] = useState(false);
  const [showCoordinateSheetModal, setShowCoordinateSheetModal] =
    useState(false);
  const [showBulkEditPerformerLabelModal, setShowBulkEditPerformerLabelModal] =
    useState(false);
  const [showExportDialog, setShowExportDialog] = useState(false);
  const [showDeletePerformersModal, setShowDeletePerformersModal] =
    useState(false);
  const [isShortcutsOpen, setIsShortcutsOpen] = useState(false);
  const [fieldEditorData, setFieldEditorData] = useState<FieldEditorData>({
    editMode: "PAN",
    setEditMode: (editMode: string) => {
      setEditMode(editMode);
    },
    showAudioTrackModal: false,
    setShowAudioTrackModal: (showAudioTrackModal: boolean) => {
      setShowAudioTrackModal(showAudioTrackModal);
    },
    showFeildSettingsModal: false,
    setShowFeildSettingsModal: (showFeildSettingsModal: boolean) => {
      setShowFeildSettingsModal(showFeildSettingsModal);
    },
    showPerformerLabelModal: false,
    setShowPerformerLabelModal: (showPerformerLabelModal: boolean) => {
      setShowPerformerLabelModal(showPerformerLabelModal);
    },
    showCoordinateSheetModal: false,
    setShowCoordinateSheetModal: (showCoordinateSheetModal: boolean) => {
      setShowCoordinateSheetModal(showCoordinateSheetModal);
    },
    showBulkEditPerformerLabelModal: false,
    setShowBulkEditPerformerLabelModal: (
      showBulkEditPerformerLabelModal: boolean
    ) => {
      setShowBulkEditPerformerLabelModal(showBulkEditPerformerLabelModal);
    },
    showExportDialog: false,
    setShowExportDialog: (showExportDialog: boolean) => {
      setShowExportDialog(showExportDialog);
    },
    showDeletePerformersModal: false,
    setShowDeletePerformersModal: (showDeletePerformersModal: boolean) => {
      setShowDeletePerformersModal(showDeletePerformersModal);
    },
    isShortcutsOpen: false,
    setIsShortcutsOpen: (isShortcutsOpen: boolean) => {
      setIsShortcutsOpen(isShortcutsOpen);
    },
  });

  return {
    fieldEditorData,
    setFieldEditorData,
  };
}
